var _rect, _rect2, _rect3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#006C35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.5,
    width: 18,
    height: 1.2,
    fill: "#fff",
    rx: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9.2,
    width: 14,
    height: 1.2,
    fill: "#fff",
    rx: 0.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "17,9.2 21.5,10.3 17,11.5",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/sa.83d19a769b30fb5e452ce585925450fc.svg";
export { ForwardRef as ReactComponent };